import { render, staticRenderFns } from "./fireControlRecord.vue?vue&type=template&id=5823e0c8&scoped=true&"
import script from "./fireControlRecord.vue?vue&type=script&lang=js&"
export * from "./fireControlRecord.vue?vue&type=script&lang=js&"
import style0 from "./fireControlRecord.vue?vue&type=style&index=0&id=5823e0c8&prod&lang=scss&"
import style1 from "./fireControlRecord.vue?vue&type=style&index=1&id=5823e0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823e0c8",
  null
  
)

export default component.exports